import React from 'react';
import {Link} from 'react-router';
import SortTable from '../SortTable';
import ListResults from '../ListResults';
import ListStats from '../ListStats';
import shallowequal from 'shallowequal';
import filter from "../../filter";
import {executeBackendQuery} from "../../requests/executeBackendQuery";
import {FIRMS_LIST, FIRMS_LIST_COUNT} from '../../consts/queries';
import FilterButton from '../FilterButton';
import FindDuplicateContacts from '../FindDuplicateContacts';
import fetchFilteredIds from '../FindDuplicateContacts/fetchFilteredIds';
import OpenInCrmButton from "../OpenInCrmButton/OpenInCrmButton";
import Icon from '../Icon';
import plus from '../../svgs/plus-white.svg';
import AddFirmModal from './AddFirmModal';
import {buildServerQuery, applyClientSort} from "../../sort-utils";

const limit = 50;

export default class FirmList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			items: null,
			totalCount: null,
			error: null,
			isBusy: null,
			addModalOpen: false,
			findDupsOpen: false,
		};

		this.openAddModal = this.openAddModal.bind(this);
		this.closeAddModal = this.closeAddModal.bind(this);
		this.handleFirmAdded = this.handleFirmAdded.bind(this);
	}

	openAddModal() {
		this.setState({addModalOpen: true});
	}

	closeAddModal() {
		this.setState({addModalOpen: false});
	}

	handleFirmAdded() {
		this.setState({addModalOpen: false});
		this.fetch(this.props.location.query);
	}

    componentDidMount() {
		this.fetch(this.props.location.query);
	}

	fetch(q) {
		this.setState({isBusy: true});

        const query = {...q};
        const options = filter(buildServerQuery(query), 'firms');
        options.param.limit = limit;
        options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

        Promise.all([
            executeBackendQuery({queryName: FIRMS_LIST, options: options}),
            executeBackendQuery({queryName: FIRMS_LIST_COUNT, options: options})
        ]).then(res => {
            this.setState({
                items: applyClientSort(res[0].data, query.order),
                totalCount: res[1].success && res[1].data[0] ? Number(res[1].data[0].TOTAL_COUNT) : false,
                error: res[0].success ? null : res[0].message,
                isBusy: null,
            });
        });
	}

	componentDidUpdate(prevProps) {
		if (!shallowequal(prevProps.location.query, this.props.location.query)) {
			this.fetch(this.props.location.query);
		}
	}

	render() {
		const query = this.props.location.query;

		const columns = [
			{
				code: 'NAME',
				name: 'Company',
				render: (el)=> <Link to={{pathname: `${arc.path.base}firm/${el.ARCIMEDES_ROW_ID}`}}>{el.NAME}</Link>,
			},
			{
				code: 'ADDRESS',
				name: 'Address',
				render: (el)=> el.ADDRESS,
			},
			{
				code: 'CITY',
				name: 'City',
				render: (el)=> el.CITY,
			},
			{
				code: 'STATE',
				name: 'State',
				render: (el)=> el.STATE,
			},
			{
				code: 'PHONE',
				name: 'Phone',
				render: (el)=> el.PHONE ? <a href={`tel:${el.PHONE.replace(' ','-').replace('(','').replace(')','')}`}>{el.PHONE}</a> : null,
			},
            {
                name: 'CRM',
                columnStyle: { minWidth: 120 },
                render: (el)=> (
                    <OpenInCrmButton
                        leadId={el.CRM_ID}
                        entityType="organization"
                        variant="link"
                        label="Open in CRM"
                    />
                ),
            },
            {
                code: 'WEBSITE',
                name: 'Website',
                render: (el)=> el.WEBSITE,
            },
		];

		const totalCount = this.state.totalCount;
		const stats = (totalCount !== null && totalCount !== false) ? { count: totalCount } : null;

		return (
            <div className='FirmList' data-is-busy={this.state.isBusy}>
				<div className='page-rounded-corner-container'>
					<div className='page-header-container list'>
						<ListStats stats={stats} query={query} variant="firms" />
						<div className='page-header list' style={{flexDirection: 'column', alignItems: 'flex-start', marginTop: '15px' }}>
							<div style={{display: 'flex', alignItems: 'center', gap: '10px', width: '100%'}}>
								<div className='page-title'>Firms</div>
								<button type="button" className="button-new plus positive" onClick={this.openAddModal} title="Add Firm">
									<Icon svg={plus}/>
								</button>
								<button
									type="button"
									className="button-new text"
									onClick={() => this.setState({findDupsOpen: true})}
									title="Find firms recorded more than once"
								>
									Find Dups
								</button>
							</div>
							<FilterButton onClick={this.props.openFilter} />
						</div>
						<div className='line'/>
					</div>
				</div>
				<FindDuplicateContacts
					open={this.state.findDupsOpen}
					entity="firms"
					label="Firm"
					plural="Firms"
					route="firm"
					fetchFilteredSet={() => fetchFilteredIds(FIRMS_LIST, 'firms', query)}
					filteredCount={this.state.totalCount}
					onClose={() => this.setState({findDupsOpen: false})}
				/>
				<div className='page-body-container'>
					<SortTable columns={columns}
							items={this.state.items}
							query={query}
					/>
					<ListResults query={this.props.location.query}
								pathname={this.props.location.pathname}
								error={this.state.error}
								totalCount={this.state.totalCount}
								itemCount={this.state.items ? this.state.items.length : false}
								limit={limit}
					/>
				</div>
				<AddFirmModal
					show={this.state.addModalOpen}
					onClose={this.closeAddModal}
					onCreated={this.handleFirmAdded}
				/>
            </div>
		);
	}
}
